import { createSelector } from 'reselect'
import { NETWORK_DOMAIN, NETWORK_KEY } from 'modules/training/modules/network/constants'

function getRequestsNetworkSelector () {
  return createSelector(
    state => state[NETWORK_DOMAIN],
    domain => domain[NETWORK_KEY.REQUESTS] || []
  )
}

export default getRequestsNetworkSelector
